import { render, staticRenderFns } from "./DremioMultiPanel.vue?vue&type=template&id=7b497d02&scoped=true"
import script from "./DremioMultiPanel.vue?vue&type=script&lang=js"
export * from "./DremioMultiPanel.vue?vue&type=script&lang=js"
import style0 from "./DremioMultiPanel.vue?vue&type=style&index=0&id=7b497d02&prod&lang=pcss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b497d02",
  null
  
)

export default component.exports